import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useTheme } from "@mui/material";

interface SecurityClearanceErrorMessageProps {
  message: string;
  testId?: string;
}

const SecurityClearanceErrorMessage = ({ message, testId }: SecurityClearanceErrorMessageProps) => {
  const theme = useTheme();

  return (
    <div
      className="flex flex-row my-2 items-center"
      style={{ color: theme.palette.error.main }}
      data-testid={testId}
    >
      <HighlightOffIcon className="mr-1" />
      <p>{message}</p>
    </div>
  );
};

export default SecurityClearanceErrorMessage;
